const prompts = {
    deals: {
        delete: {
            title: 'Delete Opportunity',
            message: 'Are you sure you want to delete this opportunity?'
        }
    },
    lists: {
        delete: {
            title: 'Delete List',
            message: 'Are you sure you want to delete this list?',
            error: 'An error has occurred while deleting this list.'
        }
    },
    contacts: {
        delete: {
            title: 'Delete Contact',
            message: 'Are you sure you want to delete this contact?',
            error: 'An error has occurred while deleting this contact.'
        }
    },
    users: {
        delete: {
            title: 'Delete User',
            message: 'Are you sure you want to delete this user?',
            error: 'An error has occurred while deleting this user.'
        }
    },
    listContacts: {
        post: {
            error: 'An error has occurred while adding the contact to the list.'
        },

        delete: {
            error: 'An error has occurred while removing the contact from the list.'
        }
    },
    category: {
        delete: {
            title: 'Delete Category',
            message: 'Are you sure you want to delete this category?',
            error: 'An error has occurred while deleting this category.'
        }
    },

    library: {
        delete: {
            title: 'Delete Item',
            message: 'Are you sure you want to delete this item?',
            error: 'An error has occurred while deleting this item.'
        }
    },
};

export default prompts;